/** Small formatting + status-grouping helpers shared across portal pages. */

export const formatDate = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  // new Date('garbage') doesn't throw — it yields an Invalid Date whose
  // toLocaleDateString() is the literal string "Invalid Date". Guard for it.
  if (isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatMoney = (v) => {
  if (v === null || v === undefined || v === '' || isNaN(Number(v))) return '';
  return `₹ ${Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
};

// Status groupings from the BE note (§3/§4/§5).
export const ORDER_GROUPS = {
  active: ['confirmed', 'delivery_assigned', 'loading', 'loaded', 'in_transit'],
  past: ['delivered', 'invoiced'],
};

export const PO_GROUPS = {
  active: ['confirmed', 'partial_advice_created', 'advice_created', 'loading', 'loaded', 'in_progress'],
  past: ['received', 'completed'],
};

export const INQUIRY_STATUSES = ['pending', 'approved', 'rejected', 'converted'];

/**
 * A single list endpoint takes one `status` value. For an Active/Past tab that
 * spans several statuses, we fetch the union client-side by calling once per
 * status and merging. This helper builds the per-status param list.
 */
export const statusesForGroup = (groups, group) => {
  if (group === 'all' || !group) return [undefined]; // one call, no status filter
  return groups[group] || [undefined];
};
